import PropTypes from 'prop-types';
import React from 'react';
import styled, { css, keyframes } from 'styled-components';

const enterProgressIcon = keyframes`
  0% {
    stroke-dasharray: 0 100;
  }
`;

const Container = styled.div`
  color: var(--purpleS);
  cursor: pointer;
  display: block;

  svg {
    display: block;
    height: 1.75rem;
    width: 1.75rem;
  }
  path {
    animation: ${enterProgressIcon} 400ms var(--quintOut) forwards;
    fill: none;
    stroke-dasharray: 100, 100;
    stroke-linecap: butt;
    stroke-width: 6;
    stroke: var(--purple-grayT);
    &:nth-of-type(2) {
      stroke: var(--green);
      ${props => props.stepNumber && css`
        stroke-dasharray: ${props.stepNumber*23.25}, 100;
      `}
    }
  }

  @media (min-width: 50em) {
    display: none;
  }
`;

const ProgressIcon = ( {stepNumber, _handleProgressClick} ) => (
  <Container stepNumber={stepNumber} onClick={_handleProgressClick}>
    <svg viewBox="0 0 36 36">
      <path d="M18 3
        a 12 12 0 0 1 0 30
        a 12 12 0 0 1 0 -30"
      />
      {stepNumber !== 0 &&
        <path d="M18 3
          a 12 12 0 0 1 0 30
          a 12 12 0 0 1 0 -30"
        />
      }
    </svg>
  </Container>
);

ProgressIcon.propTypes = {
  stepNumber: PropTypes.number.isRequired,
};

export default ProgressIcon;



// WEBPACK FOOTER //
// ./src/layouts/ProjectLayout/ProgressIcon.js